import { Injectable } from '@angular/core';
import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { LoanCarCreateComponent }  from './loan-car-create.component';
import { LoanCarReturnComponent }  from './loan-car-return.component';
import { LoanCarReviewComponent }  from './loan-car-review.component';

import { ApiService }              from '../api/api.service';
import { LoanCarService as LoanCarApi } from './loan-car.service';

declare var moment: any;

export function LoanCarService (
  $uibModal: any,
  $q: any,
  loanCarApi: any,
  workshopAPI: any
) {

  var LoanCar = function ( loanCar = {} ) {
    var self = this;

    this.loanCar = loanCar;

    this.crud = {
      save: () => self.loanCar.id ? 'patch' : 'post'
    };

    this.routes = {
      save: () => self.loanCar.id ? '/loan_car' : '/loan_cars'
    };

    this.init();

  };

  LoanCar.prototype.configureUpdate = function (loanCar) {
    var self = this;

    self.loanCar.start_date = loanCar.local_booking_start_time ? moment(loanCar.local_booking_start_time).format() : null;

    if (loanCar.local_booking_start_time) {


      self.loanCar.start_date = moment(loanCar.local_booking_start_time).format('DD/MM/YYYY');


    }

  };

  LoanCar.prototype.init = function () {
    var self = this;

    // Set the local_start_time and local_return_time
    // based off the booking's start and return times.
    if (self.loanCar.local_booking_start_time && self.loanCar.local_booking_end_time) {
      self.loanCar.start_time = moment(self.loanCar.local_booking_start_time, 'YYYY-MM-DDThh:mm:ssZ').format('hh:mm:ss A');
      self.loanCar.return_time = moment(self.loanCar.local_booking_end_time, 'YYYY-MM-DDThh:mm:ssZ').format('hh:mm:ss A');

      console.log(self.loanCar);

      // Set the local_start_date and local_return_date
      // based off the booking's start and return dates.
      self.loanCar.start_date = moment(self.loanCar.local_booking_start_time, 'YYYY-MM-DDThh:mm:ssZ').format('YYYY-MM-DD');
      self.loanCar.return_date = moment(self.loanCar.local_booking_end_time, 'YYYY-MM-DDThh:mm:ssZ').format('YYYY-MM-DD');
    } else {
      self.loanCar.start_time = moment(self.loanCar.start_time, 'HH:mm:ss').format('hh:mm:ss A')
      self.loanCar.return_time = moment(self.loanCar.return_time, 'HH:mm:ss').format('hh:mm:ss A')
    };
  };

  LoanCar.prototype.manageLoanVehicle = function ( id ) {
    return loanCarApi.manageLoanVehicle(id);
  };

  LoanCar.prototype.modifyLoan = function () {
    var self = this;

    return Promise.all([
      workshopAPI.get('/system/state_types/', null, 'states'),
      self.loanCar.loan_vehicle_id ? workshopAPI.get('/loan_vehicle', self.loanCar.loan_vehicle_id) : null,
      self.loanCar.invoice_id ? workshopAPI.get('/invoice', self.loanCar.invoice_id) : null,
      self.loanCar.event_id ? workshopAPI.get('/event', self.loanCar.event_id) : null,
      self.loanCar.customer_id ? workshopAPI.get('/customer', self.loanCar.customer_id) : null,
      workshopAPI.get('/loan_vehicle/available_vehicles_list', [self.loanCar.local_booking_start_time, self.loanCar.local_booking_end_time, self.loanCar.id])
    ]).then(function ([states, loanVehicle, invoice, event, customer, availableVehicles]) {
      var serviceInstance = new LoanCar(self.loanCar);

      var modalRef = $uibModal.open(LoanCarCreateComponent, { windowClass: 'x-lg-modal' });

      modalRef.componentInstance.context           = 'base';
      modalRef.componentInstance.loanCar            = self.loanCar;
      modalRef.componentInstance.loanVehicle        = loanVehicle;
      modalRef.componentInstance.customer           = customer;
      modalRef.componentInstance.event              = event;
      modalRef.componentInstance.invoice            = invoice;
      modalRef.componentInstance.states             = states || [];
      modalRef.componentInstance.availableVehicles  = availableVehicles || [];
      modalRef.componentInstance.serviceInstance    = serviceInstance;

      return modalRef.result;
    });
  };

  LoanCar.prototype.returnLoan = function () {
    var self = this;

    return Promise.all([
      self.loanCar.loan_vehicle_id ? workshopAPI.get('/loan_vehicle', self.loanCar.loan_vehicle_id) : null,
      self.loanCar.confirmed_by_before ? workshopAPI.get('/service_adviser', self.loanCar.confirmed_by_before) : null,
      self.loanCar.confirmed_by_return ? workshopAPI.get('/service_adviser', self.loanCar.confirmed_by_return) : null,
      self.loanCar.invoice_id ? workshopAPI.get('/invoice', self.loanCar.invoice_id) : null,
      self.loanCar.event_id ? workshopAPI.get('/event', self.loanCar.event_id) : null,
      self.loanCar.customer_id ? workshopAPI.get('/customer', self.loanCar.customer_id) : null
    ]).then(function ([ loanVehicle, adviserBefore, adviserReturn, invoice, event, customer ]) {
      var modalRef = $uibModal.open(LoanCarReturnComponent, { windowClass: 'x-lg-modal' });

      modalRef.componentInstance.loanCar              = self.loanCar;
      modalRef.componentInstance.loanVehicle           = loanVehicle;
      modalRef.componentInstance.serviceAdviserBefore  = adviserBefore;
      modalRef.componentInstance.serviceAdviserReturn  = adviserReturn;
      modalRef.componentInstance.invoice               = invoice;
      modalRef.componentInstance.event                 = event;
      modalRef.componentInstance.customer              = customer;

      return modalRef.result;
    });
  };

  LoanCar.prototype.reviewLoan = function () {
    var self = this;

    return Promise.all([
      self.loanCar.loan_vehicle_id ? workshopAPI.get('/loan_vehicle', self.loanCar.loan_vehicle_id) : null,
      self.loanCar.confirmed_by_before ? workshopAPI.get('/service_adviser', self.loanCar.confirmed_by_before) : null,
      self.loanCar.confirmed_by_return ? workshopAPI.get('/service_adviser', self.loanCar.confirmed_by_return) : null,
      self.loanCar.invoice_id ? workshopAPI.get('/invoice', self.loanCar.invoice_id) : null,
      self.loanCar.event_id ? workshopAPI.get('/event', self.loanCar.event_id) : null
    ]).then(function ([ loanVehicle, adviserBefore, adviserReturn, invoice, event ]) {
      var modalRef = $uibModal.open(LoanCarReviewComponent, { windowClass: 'x-lg-modal' });

      modalRef.componentInstance.loanCar              = self.loanCar;
      modalRef.componentInstance.loanVehicle           = loanVehicle;
      modalRef.componentInstance.serviceAdviserBefore  = adviserBefore;
      modalRef.componentInstance.serviceAdviserReturn  = adviserReturn;
      modalRef.componentInstance.invoice               = invoice;
      modalRef.componentInstance.event                 = event;

      return modalRef.result;
    });
  };

  LoanCar.prototype.save = function ( loanCar ) {
    const self = this;

    self.loanCar.local_booking_start_time = self.loanCar.start_time
      ? self.loanCar.start_date + moment(self.loanCar.start_time, 'hh:mm:ss A').format('THH:mm:ssZ')
      : null;

    self.loanCar.local_booking_end_time = self.loanCar.return_time
      ? self.loanCar.return_date + moment(self.loanCar.return_time, 'hh:mm:ss A').format('THH:mm:ssZ')
      : null;

    const params = {
      loan_car: self.loanCar,
      ...( self.loanCar.loan_status === 'A' && { update_duration: true } )
    };

    return workshopAPI[ self.crud.save() ](self.routes.save(), params);
  };

  return LoanCar;
}

@Injectable({ providedIn: 'root' })
export class LoanCarBaseFactory {
  constructor (
    private $uibModal: NgbModal,
    private loanCarApi: LoanCarApi,
    private apiService: ApiService
  ) {}

  create ( loanCar: any ): any {


    const Ctor = LoanCarService(
      this.$uibModal,
      null,
      this.loanCarApi,
      this.apiService
    );

    return new (Ctor as any)(loanCar);


  }
}